<template>
  <div class="wrapp-product-result">
    <!-- Category -->
    <div class="wrapp-categories">
      <ul class="wrapp-categories-list">
        <li v-for="category in searchResponseCategory" :key="category.value">
          <router-link :to="category.to" class="bcm-link bcm-link-primary">
            {{category.label}}
          </router-link>
        </li>
        <li class="ml-auto" v-show="searchResponseProduct.length">
          <router-link :to="{ name: 'search', query: { q: inputText }}" class="bcm-link bcm-link-primary text-uppercease cl-gray">
            {{ $t('view-all') }}
          </router-link>
        </li>
      </ul>
    </div>
    <!-- Products -->
    <div class="wrapp-products">
      <div class="wrapp-products-wrapp">
        <ul class="wrapp-products-wrapp-list">
          <li v-for="product in searchResponseProduct" :key="product.id" class="wrapp-products-wrapp-list-item">
            <productTile :product="product" />
          </li>
          <li v-show="!searchResponseProduct.length">
            <div class="no-products text-center mt-4">
              {{ $t('no-products-found') }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import find from 'lodash/find'
import { getLocalizedByUrl } from '@/helpers/routeHelpers'
import Config from 'config'
import ProductTile from 'theme/components/Search/Tiles/ProductTile'

export default {
  name: 'Products',
  props: {
    searchResponse: {
      type: Array | Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    searchResponseCategory () {
      const _this = this
      let category
      if (this.searchResponse && this.searchResponse.categoryAggregations && this.searchResponse.categoryAggregations.count) {
        return this.searchResponse.categoryAggregations.options.slice(0, Config.Theme.searchSuggestions.categoryLimit)
          .map(item => {
            category = find(_this.$store.state.category.flatted, { id: parseInt(item.value) })
            item.to = getLocalizedByUrl(_this.$store.state.ui.urlCode, category.url_path + _this.$store.state.storeConfig.config.category_url_suffix)
            return item
          })
      }
      return []
    },
    searchResponseProduct () {
      if (this.searchResponse && this.searchResponse.items) {
        return this.searchResponse.items.slice(0, Config.Theme.searchSuggestions.productLimit)
      }
      return []
    },
    totalCount () {
      if (this.searchResponse) {
        return this.searchResponse.total_count
      } else {
        return 0
      }
    }
  },
  components: {
    ProductTile
  }
}
</script>
